import React, { useState, useEffect } from "react";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import { Stack, Box } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { getClusters } from "../Clusters/Clusters";
import axiosInstance from "../../Api/axios.instance";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import { IconButton } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import useSession from "../../CustomHooks/useSession";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { MobileDatePicker } from "@mui/x-date-pickers/MobileDatePicker";
import dayjs from "dayjs";
import {
  Grid,
  InputLabel,
  Menu,
  MenuItem,
  TextareaAutosize,
  Divider,
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Typography,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
} from "@mui/material";
const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});
export default function AddTeacher({ staff, classes, subjects }) {
  const [clusters, setClusters] = useState([]);
  const [schoolID, setSchoolId] = useState("");
  const [regionID, setRegionId] = useState("");
  const [leaves, setLeaves] = useState([]);
  const { accesLevel, access } = useSession();
  const [recommendedPay, setRecommendedPay] = useState("");
  const [selectedData, setSelectedData] = useState({});
  const [editData, setEditData] = useState({});
  const [anchorEl, setAnchorEl] = useState(null);
  const [statusReviewOpen, setStatusReviewOpen] = useState(false);
  const openAnchor = Boolean(anchorEl);
  const [variables, setVariables] = useState([]);
  const { currentPage } = useSession();
  const [currentPageCRUD] = React.useState(
    currentPage[0] ? currentPage[0] : "",
  );
  const [snack, setSnack] = React.useState({
    open: false,
    message: "",
    type: "success",
  });
  const [formData, setFormData] = useState({
    RegionId: regionID,
    SchoolID: schoolID,
    TeacherId: "",
    LeaveDate: null,
    LeaveDays: null,
    WithPay: null,
    PendingStatus: 1,
    LeaveReason: "",
    Remarks: "",
  });
  const [openStatusEdit, setOpenStatusEdit] = useState(false);
  const handleStatusEditClose = () => {
    setOpenStatusEdit(false);
  };
  const handleStatusEditOpen = () => {
    setOpenStatusEdit(true);
    setAnchorEl(null);
  };
  const _onDelete = async (e) => {
    e.preventDefault();
    try {
      const { data, status } = await axiosInstance.delete(
        `/teacher-leave/${editData.LeaveId}`,
      );
      if (status === 200) {
        setSnack({
          open: true,
          type: "error",
          message: data.message,
        });
        await _fetchLeaves();
      }
    } catch (error) {
      console.log(error);
    }
  };

  const _fetchLeaveReasonsVariables = async () => {
    try {
      const { data, status } = await axiosInstance.get(
        "/variables/variables-leave-reasons",
      );
      console.log("Variables", data.data);
      if (status === 200) {
        setVariables(data.data);
      }
    } catch (error) {
      console.log(error);
    }
  };
  const _fetchLeaves = async () => {
    try {
      const { data } = await axiosInstance.get(`/teacher-leave`);
      console.log("Leaves", data.data);
      if (Object.keys(data).length > 0) {
        const sortedLeaves = [...data.data].sort(
          (a, b) => new Date(b.LeaveDate) - new Date(a.LeaveDate),
        );
        setLeaves(sortedLeaves);
      }
    } catch (error) {
      console.log(error);
    }
  };
  const _fetchClusters = async () => {
    try {
      const response = await getClusters();
      setClusters(response.data);
      console.log("clusters", response.data);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    console.log("here is the staff", staff);
    if (accesLevel === "SCHOOL") {
      const accessObject = Object.assign({}, access);
      const schoolID = accessObject[0].SchoolId;
      console.log("school_id", schoolID);
      setSchoolId(schoolID);
    }
    if (accesLevel === "ADMIN") {
      const regionID = JSON.parse(localStorage.getItem("UserAccess"))[0]
        .RegionId;
      console.log("region id", regionID);
      if (regionID) {
        setRegionId(regionID);
        console.log("regionId", regionID);
      }
      const schoolID = JSON.parse(localStorage.getItem("UserAccess"))[0]
        .SchoolId;
      console.log("school id", schoolID);
      if (schoolID) {
        setSchoolId(schoolID);
        console.log("schoolId", schoolID);
      }
    }
    _fetchLeaveReasonsVariables();
    _fetchLeaves();
    _fetchClusters();
  }, []);
  const handleSnakClose = () => {
    setSnack((prevState) => {
      return {
        ...prevState,
        open: false,
      };
    });
  };
  const handleIconClick = (leave) => (event) => {
    console.log("event", event);
    setAnchorEl(event.currentTarget);
    setEditData(leave);
  };
  const _handleOnClick = (leave) => (e) => {
    console.log(leave);
    setSelectedData(leave);
    setRecommendedPay(
      leave.WithPay > 0
        ? "With Pay"
        : leave.WithoutPay > 0
          ? "Without Pay"
          : "",
    );
    setStatusReviewOpen(true);
  };
  const handleStatusReviewClose = () => {
    setStatusReviewOpen(false);
  };
  const _handleOnChange = (e) => {
    setFormData((prevValue) => {
      return {
        ...prevValue,
        [e.target.name]: e.target.value,
      };
    });
  };
  const handleAnchorClose = () => {
    setAnchorEl(null);
  };
  const _handleLeaveDate = (e) => {
    console.log("data of leave", dayjs(e).format("YYYY-MM-DD"));
    setFormData((prevState) => {
      return {
        ...prevState,
        LeaveDate: dayjs(e).format("YYYY-MM-DD"),
      };
    });
  };
  const _onAddTeacher = async (e) => {
    e.preventDefault();
    const LeaveData = {
      TeacherId: formData.TeacherId,
      LeaveDate: formData.LeaveDate,
      LeaveDays: formData.LeaveDays,
      LeaveReason: formData.LeaveReason,
      Remarks: formData.Remarks,
      PendingStatus: 1,
      WithPay: formData.WithPay === 1 ? formData.LeaveDays : null,
      WithoutPay: formData.WithPay === 0 ? formData.LeaveDays : null,
    };
    console.log("formData", LeaveData);
    const isInvalid =
      !LeaveData.TeacherId ||
      !LeaveData.LeaveDate ||
      !LeaveData.LeaveDays ||
      !LeaveData.LeaveReason;
    if (isInvalid) {
      setSnack({
        open: true,
        type: "error",
        message: "Please fill all the required fields.",
      });
      return;
    }
    try {
      const { data, status } = await axiosInstance.post(
        "/teacher-leave",
        LeaveData,
      );
      setSnack({
        open: true,
        type: "success",
        message: "Teacher leave applied successfully",
      });
      console.log("All posts:", data.data);
      // Reset form data
      setFormData({
        TeacherId: "",
        LeaveDate: null,
        LeaveDays: "",
        WithPay: null,
        LeaveReason: "",
        Remarks: "",
        PendingStatus: 1,
      });
      await _fetchLeaves();
    } catch (error) {
      console.log("errors!!: ", error);
      setSnack({
        open: true,
        type: "error",
        message:
          error?.response?.data?.message ||
          "There was an error, please contact administrator.",
      });
    }
  };
  const _onStatusUpdate = async (e) => {
    console.log(formData);
    e.preventDefault();
    console.log("selectedData", selectedData);
    const updateStatus = {
      WithPay: selectedData.WithPay || 0,
      WithoutPay: selectedData.WithoutPay || 0,
      StatusChangeReason: selectedData.StatusChangeReason,
      PendingStatus: 0,
    };
    console.log(updateStatus);
    try {
      const exceedLimit =
        Number(updateStatus.WithPay) + Number(updateStatus.WithoutPay) !==
        Number(selectedData.LeaveDays);
      if (exceedLimit) {
        setSnack({
          open: true,
          type: "error",
          message:
            "Updated leave days cannot be more or less than total requested leave days.",
        });
        return;
      } else {
        const { data, status } = await axiosInstance.put(
          `/teacher-leave/${selectedData.LeaveId}`,
          updateStatus,
        );
        console.log("Response after update: ", data.data);
        if (status === 200) {
          setSnack({
            open: true,
            type: "success",
            message: data.message,
          });

          handleStatusReviewClose();
          await _fetchLeaves();
        }
      }
    } catch (error) {
      console.log(error);
    }
  };
  const isInCurrentSession = (date) => {
    const now = dayjs();
    const leaveDate = dayjs(date);
    const startYear = now.month() >= 6 ? now.year() : now.year() - 1;
    const sessionStart = dayjs(`${startYear}-07-01`);
    const sessionEnd = sessionStart.add(1, "year").subtract(1, "day");
    return (
      leaveDate.isAfter(sessionStart.subtract(1, "day")) &&
      leaveDate.isBefore(sessionEnd.add(1, "day"))
    );
  };
  const _handleOnUpdateStatus = (e) => {
    setSelectedData((prevState) => {
      return {
        ...prevState,
        [e.target.name]: e.target.value,
      };
    });
  };
  const _handleOnEdit = (e) => {
    console.log("testing Edit", e.target.value);
    setEditData((prevState) => {
      return {
        ...prevState,
        [e.target.name]: e.target.value,
      };
    });
  };
  const _onEdit = async (e) => {
    console.log(formData);
    e.preventDefault();
    console.log("editData", editData);
    const updateStatus = {
      LeaveDays: editData.LeaveDays,
      WithPay: editData.WithPay || 0,
      WithoutPay: editData.WithoutPay || 0,
    };
    console.log(updateStatus);
    try {
      const withPay = Number(editData.WithPay || 0);
      const withoutPay = Number(editData.WithoutPay || 0);
      const leaveDays = Number(editData.LeaveDays);
      const totalAllocated = withPay + withoutPay;
      const exceedLimit = totalAllocated !== leaveDays;
      if (exceedLimit) {
        setSnack({
          open: true,
          type: "error",
          message:
            "Updated leave days cannot be more or less than total requested leave days.",
        });
        return;
      } else {
        const { data, status } = await axiosInstance.put(
          `/teacher-leave/${editData.LeaveId}`,
          updateStatus,
        );
        console.log("Response after update: ", data.data);
        if (status === 200) {
          setSnack({
            open: true,
            type: "success",
            message: data.message,
          });
          handleStatusEditClose();
          await _fetchLeaves();
        }
      }
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <Box>
      {" "}
      <Box
        sx={{
          border: 1,
          borderColor: "#1976d2",
          borderRadius: 2,
          px: 5,
          overflow: "hidden",
        }}
      >
        <Stack
          sx={{ mt: 2, mb: 2 }}
          flexDirection="row"
          alignItems="center"
          justifyContent="center"
        >
          <Typography
            variant="h6"
            component="h1"
            style={{ color: "#1976d2" }}
            sx={{ textAlign: "center" }}
          >
            Leave Application Form
          </Typography>
        </Stack>
        <Grid
          container
          spacing={2}
          sx={{ mb: 2 }}
          justifyContent="center"
          alignItems="center"
        >
          <Grid item xs={12} md={4}>
            <TextField
              select
              label="Select Teacher"
              name="TeacherId"
              value={formData.TeacherId || ""}
              onChange={_handleOnChange}
              size="small"
              fullWidth
              required
            >
              {staff.map((item) => (
                <MenuItem
                  key={item.SchoolTeachersQId}
                  value={item.SchoolTeachersQId}
                >
                  {item.TeacherName}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid item xs={12} md={4}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <MobileDatePicker
                inputFormat="DD-MM-YYYY"
                label="Date of Leave"
                name="LeaveDate"
                value={formData.LeaveDate}
                onChange={_handleLeaveDate}
                renderInput={(params) => (
                  <TextField fullWidth size="small" required {...params} />
                )}
              />
            </LocalizationProvider>
          </Grid>
          <Grid item xs={12} md={2}>
            <TextField
              size="small"
              fullWidth
              variant="outlined"
              type="number"
              inputProps={{ min: 1, max: 25 }}
              label="Leave Days"
              name="LeaveDays"
              value={formData.LeaveDays || ""}
              onChange={_handleOnChange}
              required
            />
          </Grid>
          <Grid item xs={12} md={2}>
            <TextField
              select
              label="With Pay"
              name="WithPay"
              value={formData.WithPay}
              onChange={_handleOnChange}
              size="small"
              fullWidth
            >
              <MenuItem value={1}>Yes</MenuItem>
              <MenuItem value={0}>No</MenuItem>
            </TextField>
          </Grid>
          <Grid item xs={12} md={4}>
            <TextField
              select
              label="Reason for Leave"
              name="LeaveReason"
              value={formData.LeaveReason || ""}
              onChange={_handleOnChange}
              size="small"
              fullWidth
              required
            >
              {variables.map((item) => (
                <MenuItem key={item.ID} value={item.ID}>
                  {item.Caption}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid item xs={12} md={6}>
            <TextareaAutosize
              aria-label="minimum height"
              minRows={1}
              placeholder="Remarks"
              name="Remarks"
              value={formData.Remarks || ""}
              onChange={_handleOnChange}
              style={{ width: "100%", padding: 15 }}
            />
          </Grid>
          <Grid item xs={12} md={2}>
            <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
              {currentPageCRUD.create && (
                <LoadingButton
                  onClick={_onAddTeacher}
                  variant="contained"
                  fullWidth
                >
                  Apply Leave
                </LoadingButton>
              )}
            </Box>{" "}
          </Grid>{" "}
        </Grid>
      </Box>
      <Snackbar
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        open={snack.open}
        autoHideDuration={6000}
        onClose={handleSnakClose}
      >
        <Alert
          onClose={handleSnakClose}
          severity={snack.type}
          sx={{ width: "100%" }}
        >
          {snack.message}
        </Alert>
      </Snackbar>
      <Divider sx={{ mt: 2, mb: 2 }} />
      <Stack
        sx={{ mb: 2 }}
        flexDirection="row"
        alignItems="center"
        justifyContent="space-between"
      >
        <div style={{ width: "100%" }}>
          <TableContainer component={Paper}>
            <Table
              sx={{ minWidth: 650 }}
              aria-label="simple table"
              id="my-table"
            >
              <TableHead>
                <TableRow>
                  <TableCell
                    sx={{ backgroundColor: "#e9981f", width: "30%" }}
                    colSpan={3}
                    align="left"
                    style={{ fontWeight: "bold", fontSize: "18px" }}
                  >
                    Pending
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell align="left">S.No</TableCell>
                  {accesLevel === "ADMIN" && (
                    <TableCell align="left">Region</TableCell>
                  )}
                  {accesLevel === "ADMIN" && (
                    <TableCell align="left">School</TableCell>
                  )}
                  <TableCell align="left">Teacher Name</TableCell>
                  <TableCell align="left">Designation</TableCell>
                  <TableCell align="left">Date of Leave</TableCell>
                  <TableCell align="center">Reason for Leave</TableCell>
                  <TableCell align="center">Requested Leave Days</TableCell>
                  <TableCell align="left">Principal Remarks</TableCell>
                  {accesLevel === "ADMIN" && (
                    <TableCell align="center">Action</TableCell>
                  )}
                </TableRow>
              </TableHead>
              <TableBody>
                {leaves.length > 0 &&
                  leaves
                    .filter(
                      (leave) =>
                        leave.PendingStatus === true &&
                        (accesLevel === "SCHOOL"
                          ? leave.Teacher?.SchoolDetailShiftId === schoolID
                          : true),
                    )
                    .map((leave, index) => (
                      <TableRow
                        key={index}
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                      >
                        <TableCell>{index + 1}</TableCell>
                        {accesLevel === "ADMIN" && (
                          <TableCell align="left">
                            {clusters.find(
                              (c) =>
                                c.RegionId === leave.Teacher?.School.RegionId,
                            )?.RegionName || "N/A"}
                          </TableCell>
                        )}
                        {accesLevel === "ADMIN" && (
                          <TableCell align="left">
                            {leave.Teacher?.School.NameOfSchool || ""}
                          </TableCell>
                        )}
                        <TableCell align="left" component="th" scope="row">
                          {leave.Teacher?.TeacherName || ""}
                        </TableCell>
                        <TableCell align="left" component="th" scope="row">
                          {leave.Teacher?.Designation.TeachersDesignation || ""}
                        </TableCell>
                        <TableCell align="left">
                          {dayjs(leave.LeaveDate).format("DD-MM-YYYY")}
                        </TableCell>
                        <TableCell align="center">
                          {variables.find((v) => v.ID === leave.LeaveReason)
                            ?.Caption || "N/A"}
                        </TableCell>

                        <TableCell align="center">{leave.LeaveDays}</TableCell>
                        <TableCell align="left">{leave.Remarks}</TableCell>

                        {accesLevel === "ADMIN" && (
                          <TableCell align="right">
                            <Button onClick={_handleOnClick(leave)}>
                              Review Leave
                            </Button>
                          </TableCell>
                        )}
                      </TableRow>
                    ))}
              </TableBody>
            </Table>
          </TableContainer>
          <Dialog
            fullWidth
            maxWidth="md"
            open={statusReviewOpen}
            onClose={handleStatusReviewClose}
          >
            <DialogTitle>
              <Box>
                <Typography variant="h6" component="h1">
                  Review Leave
                </Typography>
              </Box>
            </DialogTitle>
            <DialogContent>
              <Box onSubmit={_onStatusUpdate} component="form">
                <Grid
                  container
                  spacing={2}
                  sx={{ mb: 2 }}
                  alignItems="flex-start"
                >
                  <Grid item xs={12} md={6}>
                    <Typography variant="span" component="h4">
                      Teacher Name: {selectedData.Teacher?.TeacherName || ""}
                    </Typography>
                    <Typography variant="span" component="h4">
                      Designation:{" "}
                      {selectedData.Teacher?.Designation.TeachersDesignation ||
                        ""}
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    md={6}
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "left",
                      justifyContent: "center",
                    }}
                  >
                    <Typography variant="span" component="h4">
                      Requested Leave Days: {selectedData.LeaveDays || ""}
                    </Typography>
                    <Typography variant="span" component="h4">
                      Recommended: {recommendedPay}
                    </Typography>
                  </Grid>
                  <Grid item xs={12} md={12}>
                    {/* <Divider sx={{ mt: 1, mb: 2 }} /> */}
                  </Grid>
                  <Grid item xs={12} md={2}>
                    <TextField
                      size="small"
                      sx={{ display: "flex", flex: 1 }}
                      variant="outlined"
                      type="number"
                      inputProps={{ min: 0, max: selectedData.LeaveDays }}
                      label="With Pay"
                      name="WithPay"
                      value={selectedData.WithPay ?? 0}
                      onChange={_handleOnUpdateStatus}
                    />
                  </Grid>
                  <Grid item xs={12} md={2}>
                    <TextField
                      size="small"
                      sx={{ display: "flex", flex: 1 }}
                      variant="outlined"
                      type="number"
                      inputProps={{ min: 0, max: selectedData.LeaveDays }}
                      label="Without Pay"
                      name="WithoutPay"
                      value={selectedData.WithoutPay ?? 0}
                      onChange={_handleOnUpdateStatus}
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <TextareaAutosize
                      aria-label="minimum height"
                      minRows={1}
                      placeholder="Status Update Reason"
                      name="StatusChangeReason"
                      onChange={_handleOnUpdateStatus}
                      style={{ width: "100%", padding: 15 }}
                    />
                  </Grid>
                  <Grid item xs={12} md={2}>
                    <LoadingButton
                      type="submit"
                      fullWidth
                      variant="contained"
                      color="primary"
                    >
                      Update
                    </LoadingButton>
                  </Grid>
                </Grid>

                <Divider sx={{ mt: 2, mb: 2 }} />
                <Stack
                  sx={{ mb: 2 }}
                  flexDirection="row"
                  alignItems="center"
                  justifyContent="space-between"
                >
                  <div style={{ width: "100%" }}>
                    <TableContainer component={Paper}>
                      <Table
                        sx={{ minWidth: 650 }}
                        aria-label="simple table"
                        id="my-table"
                      >
                        <TableHead>
                          <TableRow>
                            <TableCell
                              colSpan={7}
                              align="left"
                              style={{ fontWeight: "bold", fontSize: "18px" }}
                            >
                              Previous Leaves for Current Session
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell align="center">SNo.</TableCell>
                            <TableCell align="center">Date of Leave</TableCell>
                            <TableCell align="center">
                              Reason for Leave
                            </TableCell>
                            <TableCell align="center">
                              Requested Leave Days
                            </TableCell>
                            <TableCell align="center">Approved</TableCell>
                            <TableCell align="center">Denied</TableCell>
                            <TableCell align="center">
                              Reason for Approval/Denial
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {leaves.length > 0 &&
                            leaves
                              .filter(
                                (leave) =>
                                  leave.PendingStatus === false &&
                                  isInCurrentSession(leave.LeaveDate) &&
                                  leave.TeacherId === selectedData.TeacherId,
                              )
                              .map((leave, index) => (
                                <TableRow
                                  key={index}
                                  sx={{
                                    "&:last-child td, &:last-child th": {
                                      border: 0,
                                    },
                                  }}
                                >
                                  <TableCell>{index + 1}</TableCell>

                                  <TableCell align="center">
                                    {dayjs(leave.LeaveDate).format(
                                      "DD-MM-YYYY",
                                    )}
                                  </TableCell>
                                  <TableCell align="center">
                                    {variables.find(
                                      (v) => v.ID === leave.LeaveReason,
                                    )?.Caption || "N/A"}
                                  </TableCell>
                                  <TableCell align="center">
                                    {leave.LeaveDays}
                                  </TableCell>
                                  <TableCell align="center">
                                    {leave.WithPay}
                                  </TableCell>
                                  <TableCell align="center">
                                    {leave.WithoutPay}
                                  </TableCell>
                                  <TableCell align="center">
                                    {leave.StatusChangeReason}
                                  </TableCell>
                                </TableRow>
                              ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </div>
                </Stack>
              </Box>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleStatusReviewClose}>Close</Button>
            </DialogActions>
          </Dialog>
        </div>
      </Stack>
      <Divider sx={{ mt: 2, mb: 2 }} />
      <Stack
        sx={{ mb: 2 }}
        flexDirection="row"
        alignItems="center"
        justifyContent="space-between"
      >
        <div style={{ width: "100%" }}>
          <TableContainer component={Paper}>
            <Table
              sx={{ minWidth: 650 }}
              aria-label="simple table"
              id="my-table"
            >
              <TableHead>
                <TableRow>
                  <TableCell
                    sx={{ backgroundColor: "#34a853", width: "30%" }}
                    colSpan={4}
                    align="left"
                    style={{ fontWeight: "bold", fontSize: "18px" }}
                  >
                    Resolved (Current Session)
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell align="left">S.No</TableCell>
                  {accesLevel === "ADMIN" && (
                    <TableCell align="left">Region</TableCell>
                  )}
                  {accesLevel === "ADMIN" && (
                    <TableCell align="left">School</TableCell>
                  )}
                  <TableCell align="left">Teacher Name</TableCell>
                  <TableCell align="center">Designation</TableCell>
                  <TableCell align="center">Date of Leave</TableCell>
                  <TableCell align="center">Reason for Leave</TableCell>
                  <TableCell align="center">Requested Leave Days</TableCell>
                  <TableCell align="center">Approved</TableCell>
                  <TableCell align="center">Denied</TableCell>
                  <TableCell align="center">
                    Reason for Approval/Denial
                  </TableCell>
                  {accesLevel === "ADMIN" && (
                    <TableCell align="right">Action</TableCell>
                  )}
                </TableRow>
              </TableHead>
              <TableBody>
                {leaves.length > 0 &&
                  leaves
                    .filter(
                      (leave) =>
                        leave.PendingStatus === false &&
                        isInCurrentSession(leave.LeaveDate) &&
                        (accesLevel === "SCHOOL"
                          ? leave.Teacher?.SchoolDetailShiftId === schoolID
                          : true),
                    )
                    .map((leave, index) => (
                      <TableRow
                        key={index}
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                      >
                        <TableCell>{index + 1}</TableCell>
                        {accesLevel === "ADMIN" && (
                          <TableCell>
                            {clusters.find(
                              (c) =>
                                c.RegionId === leave.Teacher?.School.RegionId,
                            )?.RegionName || "N/A"}
                          </TableCell>
                        )}
                        {accesLevel === "ADMIN" && (
                          <TableCell>
                            {leave.Teacher?.School.NameOfSchool || ""}
                          </TableCell>
                        )}
                        <TableCell align="left">
                          {leave.Teacher?.TeacherName || ""}
                        </TableCell>
                        <TableCell align="center">
                          {leave.Teacher?.Designation.TeachersDesignation || ""}
                        </TableCell>
                        <TableCell align="center">
                          {dayjs(leave.LeaveDate).format("DD-MM-YYYY")}
                        </TableCell>
                        <TableCell align="center">
                          {variables.find((v) => v.ID === leave.LeaveReason)
                            ?.Caption || "N/A"}
                        </TableCell>
                        <TableCell align="center">{leave.LeaveDays}</TableCell>
                        <TableCell align="center">{leave.WithPay}</TableCell>
                        <TableCell align="center">{leave.WithoutPay}</TableCell>
                        <TableCell align="center">
                          {leave.StatusChangeReason}
                        </TableCell>

                        {accesLevel === "ADMIN" && (
                          <TableCell align="right">
                            <IconButton onClick={handleIconClick(leave)}>
                              <MoreVertIcon />
                            </IconButton>
                          </TableCell>
                        )}
                      </TableRow>
                    ))}
              </TableBody>
            </Table>
          </TableContainer>
          <Menu
            id="basic-menu"
            anchorEl={anchorEl}
            open={openAnchor}
            onClose={handleAnchorClose}
            MenuListProps={{
              "aria-labelledby": "basic-button",
            }}
          >
            {currentPageCRUD.update && (
              <MenuItem onClick={handleStatusEditOpen}>Edit</MenuItem>
            )}
            {currentPageCRUD.delete && (
              <MenuItem
                onClick={(e) => {
                  _onDelete(e);
                  handleAnchorClose();
                }}
                sx={{ color: "error.main" }}
              >
                Delete
              </MenuItem>
            )}
          </Menu>
          <Dialog
            fullWidth
            maxWidth="xs"
            open={openStatusEdit}
            onClose={handleStatusEditClose}
          >
            <DialogTitle>
              {/* <Box sx={{ mb: 2 }}> */}
              <Box>
                <Typography variant="h6" component="h1">
                  Edit Leave Details
                </Typography>
              </Box>
            </DialogTitle>
            <DialogContent>
              <Box onSubmit={_onEdit} component="form">
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Typography variant="span" component="h4">
                      Teacher Name: {editData.Teacher?.TeacherName || ""}
                    </Typography>
                    <Typography variant="span" component="h4">
                      Designation:{" "}
                      {editData.Teacher?.Designation.TeachersDesignation || ""}
                    </Typography>
                  </Grid>

                  <Grid item xs={12} md={12}>
                    {/* <Divider sx={{ mt: 1, mb: 2 }} /> */}
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      size="small"
                      sx={{ display: "flex", flex: 1 }}
                      variant="outlined"
                      type="number"
                      inputProps={{ min: 0 }}
                      label="Leave Days"
                      name="LeaveDays"
                      value={editData.LeaveDays}
                      onChange={_handleOnEdit}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      size="small"
                      sx={{ display: "flex", flex: 1 }}
                      variant="outlined"
                      type="number"
                      inputProps={{ min: 0, max: editData.LeaveDays }}
                      label="With Pay"
                      name="WithPay"
                      value={editData.WithPay ?? 0}
                      onChange={_handleOnEdit}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      size="small"
                      sx={{ display: "flex", flex: 1 }}
                      variant="outlined"
                      type="number"
                      inputProps={{ min: 0, max: editData.LeaveDays }}
                      label="Without Pay"
                      name="WithoutPay"
                      value={editData.WithoutPay ?? 0}
                      onChange={_handleOnEdit}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <LoadingButton
                      type="submit"
                      fullWidth
                      variant="contained"
                      color="primary"
                    >
                      Edit Leave Details
                    </LoadingButton>
                  </Grid>
                </Grid>
              </Box>
            </DialogContent>

            <DialogActions>
              <Button onClick={handleStatusEditClose}>Close</Button>
            </DialogActions>
          </Dialog>
        </div>
      </Stack>
    </Box>
  );
}
